<!--
 * @Description:护眼常识页面从小学那边迁移过来的
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-04-14 18:47:27
 * @LastEditors: liujinlei liujinlei@zhihuiliu.com
 * @LastEditTime: 2023-12-20 12:01:05
 -->
<template>
  <div class="conten-box"
       v-if="queryNum <= 0">
    <van-nav-bar v-if="!hideHeader"
                 class="header"
                 :title="title"
                 :border="false"
                 @click-left="onClickClose">
      <template #left>
        <van-icon :name='require("@/assets/images/oralExpression/icon-close.png")'
                  size="22" />
      </template>
    </van-nav-bar>
    <div class="cont">
      <div class="progress"
           v-if="!hideHeader">
        <van-progress :percentage="percentage"
                      :show-pivot="false"
                      color="#45D585"
                      stroke-width="4" />
      </div>
      <div class="wapper"
           ref="wapper"
           :style='"padding-bottom:"+ paddingBottom +"px;"'>
        <div class="w-title"
             ref="title">
          <div class="msg"
               v-html="stems"></div>
          <!-- <span class="tag">回答问题</span>
          <van-button class="lookYuanw"
            plain
            color="#74767D"
            @click="lookYuanwFun"
            :icon="lookYuanw ? require('@/assets/images/oralExpression/icon-eye.png') : require('@/assets/images/oralExpression/icon-eye-false.png')"
            type="info"
            round>原文</van-button> -->
        </div>
        <div class="msg-box"
             :class="entry == 0 && hideHeader ? 'hideAll':''"
             ref="msgBox">
          <div class="player-box"
               :class="yuanw ? '':'noPadding'"
               v-if="audioUrl">
            <zhlAplayer :url="audioUrl"
                        ref="zhlAplayer" />
            <van-button class="lookYuanw"
                        plain
                        v-if="yuanw"
                        @click="lookYuanwFun"
                        :icon="lookYuanw ? require('@/assets/images/oralExpression/icon-eye.png') : require('@/assets/images/oralExpression/icon-eye-false.png')"
                        type="info"
                        round>原文</van-button>
            <!-- <div class="msg">听录音，口头回答问题。录音读两遍。</div> -->
            <transition name="yuanw"
                        appear>
              <div key="a"
                   class="yuanw"
                   v-if="lookYuanw && yuanw"
                   v-html="yuanw"></div>
            </transition>
          </div>
          <message v-for="(item, i) in messageList"
                   :key="i"
                   :readData="item"
                   @setScroll="setScrollFun"
                   @readThisMessage="readThisMessageFun"
                   @reluyin="reluyinFun" />
        </div>
      </div>
    </div>
    <div class="footer"
         v-show="!hideFooter"
         v-if="entry == 0">
      <div class="footer-item">
        <van-icon v-if="percentage != 100 || isPlaying"
                  :name='require("@/assets/images/oralExpression/icon-fanish-disable.png")'
                  size="40" />
        <van-icon v-else
                  @click="fanish"
                  :name='require("@/assets/images/oralExpression/icon-fanish.png")'
                  size="40" />
        <div class="name">完成</div>
      </div>
      <div class="footer-item">
        <van-icon v-if="isPlaying || !askLuyin"
                  :name='require("@/assets/images/oralExpression/icon-luyin-disable.png")'
                  size="92" />
        <van-icon v-else
                  @click="send"
                  :name='require("@/assets/images/oralExpression/icon-luyin.png")'
                  size="92" />
        <div class="name">{{ theName }}</div>
      </div>
      <div class="footer-item">
        <van-icon v-if="isPlaying || askLuyin || currentIndex == listArr.length"
                  :name='require("@/assets/images/oralExpression/icon-next-disable.png")'
                  size="40" />
        <van-icon v-else-if="currentIndex==0"
                  @click="aiSend(0)"
                  :name='require("@/assets/images/oralExpression/icon-next.png")'
                  size="40" />
        <van-icon v-else
                  @click="nextReading"
                  :name='require("@/assets/images/oralExpression/icon-next.png")'
                  size="40" />
        <div class="name">{{currentIndex == 0 ?"开始":"下一句"}}</div>
      </div>
    </div>
    <div class="asklu"
         v-if="isLuing"
         @click="stopLu">
      <div class="progressBox"
           v-if="hideHeader">
        <div class="pro">
          <van-progress :percentage="luGrade"
                        stroke-width="3"
                        :show-pivot="false"
                        color="#45D585"
                        track-color="#BFBFBF" />
        </div>

        <div class="timeBox">{{luTimeStr}}</div>
      </div>
      <div class="waveBox">
        <WaveView />
      </div>
      <div class="text"
           v-if="!hideHeader">点击波纹，结束录音</div>
      <div class="text"
           v-else>请在指定时间内完成录音或点击波纹结束录音</div>

    </div>
    <div class="player">
      <audio :src="currentMusic.url"
             @timeupdate="playingFun"
             @ended="playEnd"
             @error="playError"
             :loop="false"
             ref="aplayer"
             controls="controls"></audio>
    </div>
    <getVipTip :show="showGetVipAlert && !hideHeader"
               title="欢迎使用口语表达功能"
               @getVip="getVipFun"
               @close="showGetVipAlert = false" />
    <closeOral :show="showCloseOral"
               :type="closeOralType"
               @nextClick="goToNextMoudle"
               @close="showCloseOral = false" />
    <OralExpressionF :show="showOralExpressionF"
                     @close="showOralExpressionF = false" />
    <van-popup v-model="showAskOne"
               class="showFAlertBox"
               :close-on-click-overlay="false">
      <div class="showFAlert">
        <div class="title">提示</div>
        <div class="msg">仅有一次重录机会，确定要重录吗？</div>
        <div class="btns">
          <van-button round
                      type="primary"
                      @click="quxiaoRelu">取消</van-button>
          <van-button round
                      type="primary"
                      @click="askTheRelu">确认</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  jumpWebView,
  HttpFactory,
  getArgs
} from '@/assets/js/common'
import rqParams from './rq.js'
import '@/assets/js/engine.js'
import Oral from '@/assets/js/zhloralMain.js'
import OralweChat from '@/assets/js/zhlOralweChat.js'
import message from '@/components/Message/index'
import zhlAplayer from '@/components/Aplayer/index'
import getVipTip from '@/components/OralExpressionComponents/OralExpressionGetVip'
import closeOral from '@/components/OralExpressionComponents/OralExpressionClose'
import OralExpressionF from '@/components/OralExpressionComponents/OralExpressionF'
import WaveView from '@/components/zjEnglishComponents/WaveView'
export default {
  name: 'oralExpression',
  components: {
    message,
    getVipTip,
    zhlAplayer,
    closeOral,
    WaveView,
    OralExpressionF
  },
  props: {
    theGuid: {
      type: String,
      default: ''
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    questionItem: {
      type: Object
    },
    entry: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      business_id: null,
      luGrade: 0,
      luTimeStr: '00:00/00:00',
      showAskOne: false,
      stems: '',
      showOralExpressionF: false,
      isIOSWx: false,
      access_token: '',
      refText: '',
      isRoot: false,

      isLuing: false,

      hideFooter: false,
      showGetVipAlert: false,
      showCloseOral: false,
      closeOralType: 'all',
      lookYuanw: false, // 查看原文
      queryNum: 0,
      title: '',
      listArr: [],
      isShowGetVip: false,
      currentIndex: 0,
      currentObj: {
        isPlaying: false
      },
      percentage: 0, // 进度条
      messageList: [], // 消息队列
      audioUrl: '', // 原文的音频
      yuanw: '',
      currentMusic: {
        name: '',
        artist: '',
        url: ''
      },
      paddingBottom: 0,
      height: 0,
      timer: null,
      timer2: null,
      timer3: null,
      askLuyin: false, // 重新录音
      rePlaying: false, // 重听
      isPlaying: false, // 全局的播放状态
      theName: '点击录音',
      userInfo: {},
      nextList: [],
      guid: '',
      book_id: '',
      resource_id: '',
      model_id: '',
      type: '',
      pageType: 1 // 目前写死的页码模式，还有一个目录模式
    }
  },
  watch: {
    messageList(val) {
      const total = this.listArr.length * 2
      let num = 0
      val.forEach(el => {
        if (el.type != 'other') {
          // 说明是正常对话
          num++
        } else {
          this.isShowGetVip = true
        }
      })
      const newNum = parseInt((num / total) * 100)
      const oldNum = this.percentage
      this.numFun(oldNum, newNum, data => {
        this.percentage = data
      })
    },
    currentObj(val) {
      if (val.type == 'left' && val.url == '') {
        this.isPlaying = true
        this.currentMusic.url = './block.mp3'
        val.isShowText = true
        this.$set(val, 'hideListen', true)
      } else {
        this.isPlaying = true
        this.currentMusic.url = val.url
      }

      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (this.currentMusic.url) {
          this.$refs.aplayer.play()
        } else {
          this.playEnd()
        }
      }, 100)
    },
    questionItem(obj) { }
  },
  created() {
    Oral.initEngine()
    window.oralRecAndEvaCallback = this.oralRecAndEvaCallback
  },
  mounted() {
    const param = getArgs()
    this.guid = this.theGuid || param.guid
    this.book_id = param.book_id || 0
    this.resource_id = param.resource_id
    this.model_id = param.model_id
    this.title = param.title
    this.type = param.type
    this.business_id = param.business_id || 100002
    this.getUserInfo()
    this.getDataList()
    this.getNextList()
    jumpWebView.handleNavigator(false)
    if (typeof zhlWebView != 'undefined') {
      try {
        zhlWebView.setBouncesEnabled(0) // 禁用ios回弹
      } catch (error) { }
    }
  },
  methods: {
    getweixinjsapiconfigFun() {
      const url = location.href
      HttpFactory.postUrlPay(
        rqParams.getweixinjsapiconfig({
          app_id: 137,
          url: url
        }),
        res => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.app_id, // 必填，公众号的唯一标识
            timestamp: res.data.time_stamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ['startRecord', 'stopRecord', 'uploadVoice'] // 必填，需要使用的JS接口列表
          })
          wx.ready(() => {
            this.isRoot = true
          })
        }
      )
    },
    beginLu(msg) {
      // if (!Oral.isRoot) {
      //   this.$toast('麦克风没有被允许')
      //   return
      // }
      this.isLuing = true
      Oral.startRecord()
    },
    stopLu() {
      if (this.hideHeader) {
        clearInterval(this.luTimer)
        this.luTimeStr = '00:00/00:00'
      }
      Oral.stopRecord()
      this.isLuing = false
    },
    getUrlAndPing(id) {
      const jsonText = OralweChat.getEvalJson('wechat', this.refText, 'en.sent.rec')
      const timestamp = parseInt(new Date().getTime() / 1000) + ''
      const message = 'a658.' + timestamp + '.JSWsbEHxIvTnqPy5oZ7GOzF9LKBNr1UM'
      const sig = OralweChat.sha1(message)
      jsonText.connect.param.app.timestamp = timestamp
      jsonText.connect.param.app.sig = sig
      jsonText.start.param.app.timestamp = timestamp
      jsonText.start.param.app.sig = sig
      HttpFactory.postUrlPay(
        rqParams.getweixinvoicetestinfo({
          media_id: id,
          app_id: 137,
          json_text: JSON.stringify(jsonText),
          is_login: 1
        }),
        res => {
          this.isLuing = false
          const data = JSON.parse(res.data)
          const resultData = {}
          resultData.duration = data.result.wavetime / 1000
          resultData.audioUrl = data.audioUrl
          resultData.wordInfosArr = []
          const arr = data.result.wrd_details
          const str = []
          arr.forEach(el => {
            str.push(el.char)
          })
          resultData.resultStr = str.join(' ')
          resultData.overall = 0
          this.oralRecAndEvaCallback(JSON.stringify(resultData))
        }
      )
    },
    initEvent() {
      window.oralRecAndEvaCallback = this.oralRecAndEvaCallback
    },
    getTheAnswer(data, answer) {
      if (!answer) {
        return false
      }
      let isRight = false
      data.extra.match_answer.forEach(el => {
        console.log(answer.toLowerCase())
        console.log(el.toLowerCase())
        // 匹配的答案
        // 新加大小写转换的规则
        if (answer.toLowerCase().indexOf(el.toLowerCase()) > -1) {
          // 有匹配的答案
          isRight = true
        }
      })
      return isRight
    },
    oralRecAndEvaCallback(param) {
      this.hideFooter = false
      var data = JSON.parse(param)
      const dataFormApp = this.listArr[this.currentIndex - 1]
      // const isVip = !!(this.userInfo.member_type && this.userInfo.member_type != 1)
      const isVip = true
      let isRight = false
      try {
        isRight = this.getTheAnswer(dataFormApp, data.resultStr)
      } catch (error) { }
      if (isVip) {
        const obj = {
          id: new Date().getTime() + Math.random(),
          url: data.audioUrl,
          avatar_url: this.userInfo.avatar_url,
          audio_duration: data.duration,
          isVip: true,
          type: 'right',
          msg: data.resultStr ? data.resultStr : '语音识别失败',
          grade: 90,
          isPlaying: true,
          isAskLuyin: false,
          // 口语回答新加
          expressionType: 2,
          isAnwserRight: isRight, // 答案是否正确
          anwserTip: dataFormApp.extra.suggested_answer
        }
        this.currentObj = obj
      } else {
        const obj = {
          id: new Date().getTime() + Math.random(),
          url: data.audioUrl,
          avatar_url: this.userInfo.avatar_url,
          audio_duration: data.duration,
          isVip: false,
          type: 'right',
          isPlaying: true,
          isAskLuyin: false,
          // 口语回答新加
          expressionType: 2
        }
        this.currentObj = obj
      }
      let num = 0
      this.messageList.forEach((el, i) => {
        if (el.isAskLuyin) {
          this.messageList.splice(i, 1, this.currentObj)
          num++
        }
      })
      if (!num) {
        this.messageList.push(this.currentObj)
        if (!this.isShowGetVip && !isVip) {
          this.messageList.push({
            type: 'other',
            msg: '想要查看自己的回答情况吗？',
            expressionType: 2
          })
        }
      }
      this.askLuyin = false
    },
    getUserInfo() {
      HttpFactory.postUrl(rqParams.getstudentinfo(), res => {
        this.userInfo = Object.assign(this.userInfo, res.data)
      })
      // HttpFactory.postUrl(rqParams.getusermemberinfo(), res => {
      //   this.userInfo = Object.assign(this.userInfo, res.data)
      //   if (this.userInfo.member_type && this.userInfo.member_type != 1) {
      //     // 说明是会员
      //   } else {
      //     HttpFactory.postUrl(
      //       rqParams.getrewardresult({
      //         type: 20
      //       }),
      //       res => {
      //         if (res.data.if_pop) {
      //           // 没有领取过
      //           this.showGetVipAlert = true
      //         }
      //       }
      //     )
      //   }
      // })
    },
    // 领取免费7天会员
    getVipFun() {
      HttpFactory.postUrl(
        rqParams.submitreceivereward({
          type: 20
        }),
        res => {
          if (res.code == 0) {
            this.$toast('领取成功')
          }
          this.getUserInfo()
          this.showGetVipAlert = false
        }
      )
    },
    // 查看原文
    lookYuanwFun() {
      this.lookYuanw = !this.lookYuanw
    },
    // 数字动画
    numFun(startNum, maxNum, fn, speed = 1) {
      let numText = startNum
      let golb // 为了清除requestAnimationFrame
      function numSlideFun() {
        // 数字动画
        numText += speed // 速度的计算可以为小数 。数字越大，滚动越快
        if (numText >= maxNum) {
          numText = maxNum
          cancelAnimationFrame(golb)
        } else {
          golb = requestAnimationFrame(numSlideFun)
        }
        fn(numText)
        // console.log(numText)
      }
      numSlideFun() // 调用数字动画
    },
    requestAnimationFrame(fn) {
      const currTime = new Date().getTime()
      // 为了使setTimteout的尽可能的接近每秒60帧的效果
      const timeToCall = Math.max(0, 16 - (currTime - lastTime))
      const id = window.setTimeout(() => {
        fn(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    },
    cancelAnimationFrame(id) {
      window.clearTimeout(id)
    },
    playError() {
      if (this.messageList.length) {
        this.$toast('播放失败')
      }
    },
    playEnd() {
      if (this.currentObj.type == 'left' && !this.rePlaying) {
        this.$toast({
          message: '点击录音，回答问题',
          position: 'bottom',
          className: 'zhl-toast-bottom' + (this.theGuid ? ' more' : ''),
          duration: 1000
        })
        this.askLuyin = true
        this.theName = '点击录音'
      }
      this.currentObj.isPlaying = false
      this.isPlaying = false
      this.rePlaying = false
    },
    setLuGrate() {
      let time = 0
      this.luTimer = setInterval(() => {
        time++
        this.luTimeStr = this.getTimeStr(time, this.questionItem.answer_time)
        this.luGrade = parseInt((time / this.questionItem.answer_time) * 100)
        if (time >= this.questionItem.answer_time) {
          clearInterval(this.luTimer)
          this.stopLu()
        }
      }, 1000)
    },
    getTimeStr(cur, total) {
      const min1 = parseInt(cur / 60) < 10 ? '0' + parseInt(cur / 60) : parseInt(cur / 60)
      const min2 = parseInt(total / 60) < 10 ? '0' + parseInt(total / 60) : parseInt(cur / 60)
      const sec1 = cur % 60 < 10 ? '0' + (cur % 60) : cur % 60
      const sec2 = total % 60 < 10 ? '0' + (total % 60) : total % 60
      return min1 + ':' + sec1 + '/' + min2 + ':' + sec2
    },
    // 播放和暂停
    playingFun() {
      // const { media } = this.$refs.aplayer
      // this.currentObj.isPlaying = !media.paused
      // this.isPlaying = !media.paused
      this.currentObj.isPlaying = true
      this.isPlaying = true
    },
    // 重新听
    readThisMessageFun(obj) {
      this.rePlaying = true
      this.messageList.forEach(el => {
        el.isPlaying = false
        if (el.isAskLuyin) {
          el.isAskLuyin = false
          this.askLuyin = false
        }
      })
      this.currentObj = obj
      this.currentMusic.url = obj.url + '?time=' + new Date().getTime()
      setTimeout(() => {
        this.$refs.aplayer.play()
      }, 100)
    },
    reluyinFun(obj) {
      if (this.entry == 1) {
        this.$toast('当前模式下不能重新录音')
        return
      }
      if (this.isPlaying) {
        this.$toast('播放过程中无法重新录音')
        return
      }
      if (this.askLuyin) {
        this.$toast('请先完成上一次的问题')
        return
      }
      if (this.isAskTheRelu && this.hideHeader) {
        this.$toast('只有一次重新录音的机会')
        return
      }
      this.messageList.forEach(el => {
        el.isAskLuyin = false
      })
      obj.isAskLuyin = true
      this.askLuyin = true
      if (!this.hideHeader) {
        this.$toast({
          message: '点击录音，重新回答',
          position: 'bottom',
          className: 'zhl-toast-bottom' + (this.theGuid ? ' more' : ''),
          duration: 1000
        })
        this.thName = '重新录音'
      } else {
        this.showAskOne = true
      }
    },
    askTheRelu() {
      this.showAskOne = false
      this.showCountDown = false
      this.setLuGrate()
      this.send()
      this.isAskTheRelu = true
      this.$emit('disabledNext')
    },
    quxiaoRelu() {
      this.showAskOne = false
      this.messageList.forEach((el) => {
        el.isAskLuyin = false
      })
      this.askLuyin = false
    },
    setScrollFun(el) {
      this.$nextTick(() => {
        const container = this.$refs.wapper
        const title = this.$refs.title
        const msgBox = this.$refs.msgBox
        this.paddingBottom = el.clientHeight
        if (msgBox.clientHeight + title.clientHeight >= container.clientHeight) {
          container.scrollTop = msgBox.clientHeight + title.clientHeight - container.clientHeight + 20
        }
        clearTimeout(this.timer2)
        this.timer2 = setTimeout(() => {
          this.paddingBottom = 0
        }, 300)
      })
    },
    // 点击关闭
    onClickClose() {
      this.showCloseOral = true
      this.closeOralType = 'close'
    },
    // 点击完成
    fanish() {
      if (this.theGuid && JSON.stringify(this.questionItem) != '{}') {
        this.$emit('fanished', 'next')
        this.$refs.zhlAplayer.stop()
        this.questionItem.if_right = 2
      } else {
        this.showCloseOral = true
        this.closeOralType = 'all'
      }
    },
    goToNextMoudle() {
      const nextList = this.deal(JSON.parse(JSON.stringify(this.nextList)), node => {
        return node.model_list.length > 0
      })
      const arr = []
      nextList.forEach((el, i) => {
        arr.push(...el.model_list)
      })
      let item = null
      arr.forEach((el, i) => {
        if (el.model_id == this.model_id) {
          item = arr[i + 1]
        }
      })
      if (item) {
        const parent = this.deal(JSON.parse(JSON.stringify(this.nextList)), node => {
          return JSON.stringify(node.model_list).indexOf(JSON.stringify(item)) > -1
        })
        const data = {
          item,
          parent: parent[0]
        }
        this.goDetailFun(data)
        // this.goqusDetailFun(qus)
      } else {
        this.showCloseOral = false
        this.showOralExpressionF = true
      }
    },
    goDetailFun(data) {
      HttpFactory.postUrl(
        rqParams.submitbookstudyrecord({
          book_id: this.book_id,
          type: data.parent.type + 1,
          business_id: 100002,
          study_type: 1,
          study_id: data.item.model_id,
          resource_id: data.parent.resource_id
        }),
        (res) => { }
      )
      HttpFactory.postUrl(
        rqParams.getmodelinfo({
          model_id: data.item.model_id
        }),
        (res) => {
          const paper_list = res.data.paper_list || []
          if (paper_list.length > 0) { // 进入试卷模式
            location.href = './zjEnglishPaperTest.html?title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
          } else {
            this.goqusDetailFun(res.data.question_list[0], data)
          }
        }
      )
    },
    deal(nodes, predicate) {
      // 如果已经没有节点了，结束递归
      if (!(nodes && nodes.length)) {
        return []
      }
      const newChildren = []
      for (const node of nodes) {
        if (predicate(node)) {
          // 如果节点符合条件，直接加入新的节点集
          newChildren.push(node)
          node.children = this.deal(node.children_list, predicate)
        } else {
          // 如果当前节点不符合条件，递归过滤子节点，
          // 把符合条件的子节点提升上来，并入新节点集
          newChildren.push(...this.deal(node.children_list, predicate))
        }
      }
      return newChildren
    },
    goqusDetailFun(qus, data) {
      if (!qus) {
        this.$toast('跳转失败，请直接退出')
        return
      }
      if (qus.sub_model_id == 5) {
        location.href = './zjEnglishListeningQuestions.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
        return
      }
      if (qus.model_id === 11) {
        if (qus.sub_model_id == 1) {
          location.href = './zjEnglishAnalogFollowUpReading.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 2) {
          location.href = './zjEnglishOralExpression.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 3) {
          location.href = './zjEnglishOralAnswerQuestions.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 4) {
          location.href = './zjEnglishOralExpressionTraining.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
        }
      } else {
        setTimeout(() => {
          this.$toast('题目信息不正确')
        }, 800)
      }
    },
    getNextList() {
      HttpFactory.postUrl(
        rqParams.getlistenspeakinfov2({
          book_id: this.book_id
        }),
        res => {
          this.nextList = res.data.catalog_list
        }
      )
    },
    // 发送
    send() {
      if (this.hideHeader) {
        this.showCountDown = false
        this.setLuGrate()
      }
      this.beginLu()
      // // 调用语音识别
      // if (typeof zhlWebView != 'undefined') {
      //   if (this.theGuid) {
      //     this.hideFooter = true
      //   }
      //   zhlWebView.oralRec()
      // }
      // let data = {
      //   duration: 60, // 录音时长 秒
      //   audioUrl: 'https://zhldebug.cdn.bcebos.com/CACAAECJ/e6a8b9d0c8f74f97b2b2322a2f245ee9.mp3', // 地址
      //   resultStr: 'yes' // 录音结果： 评测的时候就是传入的评测字符串， 识别的时候是识别出的文字
      // }
      // data = JSON.stringify(data)
      // this.oralRecAndEvaCallback(data)
    },
    nextReading() {
      this.messageList.forEach(el => {
        el.isPlaying = false
        el.isAskLuyin = false
      })
      const index = this.currentIndex
      this.aiSend(index)
    },
    aiSend(index) {
      if (this.isPlaying) {
        return
      }
      this.isPlaying = true

      index = index || 0
      const readObj = this.listArr[index]
      this.currentObj = {
        url: readObj.extra.audio_url,
        avatar_url: readObj.extra.avatar_url,
        audio_duration: readObj.extra.audio_duration,
        type: 'left',
        msg: readObj.option,
        isPlaying: true,
        isShowText: !readObj.extra.audio_duration,
        hasTip: readObj.extra.prompt_content
      }
      this.currentIndex = index
      this.currentIndex++
      this.messageList.push(this.currentObj)
    },
    getDataList() {
      if (this.theGuid && JSON.stringify(this.questionItem) != '{}') {
        this.stems = this.questionItem.stem
        this.audioUrl = this.questionItem.audio_url
        this.yuanw = this.questionItem.audio_en_text.replace(/<.*?>/gi, '')
        const obj = this.questionItem.options
        const dataArr = obj.data
        const roleArr = obj.role
        dataArr.forEach(el => {
          el.option = this.replaceKun(el.option)
          roleArr.forEach(sub => {
            if (el.extra.avatar_id == sub.avatar_id) {
              el.extra = Object.assign(el.extra, sub)
            }
          })
        })
        this.listArr = obj.data
        return
      }
      HttpFactory.postUrl(
        rqParams.getquestioninfo({
          guid: this.guid
        }),
        res => {
          // 该题型不展示题干
          if (res.data.model_id !== 11 && res.data.sub_model_id !== 3) {
            this.stems = res.data.stem
          }
          this.audioUrl = res.data.audio_url
          this.yuanw = res.data.audio_en_text.replace(/<.*?>/gi, '')
          const obj = JSON.parse(res.data.options)
          const dataArr = obj.data
          const roleArr = obj.role
          // this.title = res.data.stem.replace(/<.*?>/gi, '')
          dataArr.forEach(el => {
            el.option = this.replaceKun(el.option)
            roleArr.forEach(sub => {
              if (el.extra.avatar_id == sub.avatar_id) {
                el.extra = Object.assign(el.extra, sub)
              }
            })
          })
          this.listArr = obj.data
        }
      )
    },
    replaceKun(str) {
      return str.replace(/{_.*?_}/gi, s1 => {
        const result = s1.split('_')
        return result[1]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.conten-box {
  height: 100%;
  font-family: PingFangSC-Medium, PingFang SC;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .header {
    /deep/ .van-nav-bar__title {
      font-size: 16px;
      font-weight: bold;
      color: rgba(69, 70, 74, 1);
    }

    /deep/ .van-icon {
      &:active {
        background: #f5f5f5;
      }
    }
  }

  .cont {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .progress {
      padding: 0 15px;
      margin-bottom: 20px;
    }

    .wapper {
      flex: 1;
      overflow: auto;

      .w-title {
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 20px;

        .msg {
          font-size: 14px;
          font-weight: bold;
          color: rgba(69, 70, 74, 1);
          line-height: 20px;
        }

        .tag {
          width: 68px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          font-size: 12px;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          margin-right: 7px;
          background: rgba(116, 118, 125, 1);
          border-radius: 4px;
        }

        .lookYuanw {
          height: 25px;
          line-height: 23px;
          padding: 0 14px;
          font-size: 12px;

          /deep/ .van-button__icon {
            font-size: 16px;
          }
        }
      }

      .msg-box {
        padding: 0 15px;

        &.hideAll {
          /deep/ .message-box {
            .hasTip {
              display: none !important;
            }
          }
        }

        .player-box {
          margin-bottom: 30px;
          position: relative;

          /deep/ .aplayer-info {
            padding-right: 54px !important;
          }

          &.noPadding {
            /deep/ .aplayer-info {
              padding-right: 0px !important;
            }
          }

          /deep/ .van-button {
            padding: 0 5px;
            height: 25px;
            line-height: 25px;
            background: transparent;
            border: 0;
            position: absolute;
            right: 6px;
            top: 12px;

            .van-icon {
              font-size: 16px;
            }

            .van-button__text {
              font-size: 12px;
              font-weight: 400;
              color: rgba(69, 213, 133, 1);
            }
          }

          .msg {
            padding: 4px 15px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 16px;
            margin: 18px auto;
            margin-bottom: 0;
            background: #a4a7b0;
            display: inline-block;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 6px;
          }

          .yuanw {
            max-height: 200px;
            overflow: hidden;
            overflow-y: auto;
            background: rgba(245, 247, 250, 1);
            border-radius: 10px;
            padding: 10px 20px;
            box-sizing: border-box;
            font-size: 14px;
            font-family: HelveticaNeue-Medium, HelveticaNeue;
            font-weight: bold;
            color: rgba(69, 70, 74, 1);
            line-height: 27px;
            margin-top: 18px;
          }

          .yuanw-enter-active,
          .yuanw-leave-active {
            transition: all 0.8s;
          }

          .yuanw-enter,
          .yuanw-leave-to {
            opacity: 0;
            height: 0;
            padding: 0 20px;
            margin-top: 0px;
          }
        }
      }
    }
  }

  .footer {
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;

    .footer-item {
      margin-top: 30px;
      user-select: none;

      /deep/ .van-icon {
        &:active {
          opacity: 0.8;
        }
      }

      .name {
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: rgba(164, 167, 176, 1);
        margin-top: 22px;
      }

      &:nth-child(2) {
        margin: 0 50px;

        .name {
          margin-top: 0;
        }
      }
    }
  }

  .asklu {
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(53, 63, 79, 0.06);
    padding: 15px 0;
    box-sizing: border-box;
    flex-direction: column;

    .progressBox {
      position: absolute;
      width: 100%;
      left: 0;
      top: 10px;
      padding: 0 15px;
      box-sizing: border-box;
      display: flex;
      align-items: center;

      .pro {
        flex: 1;
        overflow: hidden;
      }

      .timeBox {
        margin-left: 5px;
        font-size: 12px;
        color: #a4a7b0;
      }
    }

    .waveBox {
      width: 100%;
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
    }

    .text {
      font-size: 13px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: rgba(69, 70, 74, 1);
    }
  }

  .player {
    display: none;
  }

  .showFAlertBox {
    background: transparent;

    .showFAlert {
      background: #fff;
      width: 293px;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 10px;

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #45464a;
        line-height: 16px;
        margin-bottom: 18px;
        text-align: center;
      }

      .msg {
        font-size: 14px;
        color: #74767d;
        line-height: 26px;
        text-align: center;
        margin-bottom: 20px;
      }

      .btns {
        width: 100%;
        display: flex;
        justify-content: space-between;

        /deep/ .van-button {
          width: 120px;
          height: 40px;
          border-color: #45d585;
          background: #45d585;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;

          &:first-child {
            border-color: #979797;
            background: #fff;
            color: #74767d;
          }
        }
      }
    }
  }
}
</style>
